import { render, staticRenderFns } from "./ADQjhTable.vue?vue&type=template&id=a5ff8b1a&scoped=true"
import script from "./ADQjhTable.vue?vue&type=script&lang=js"
export * from "./ADQjhTable.vue?vue&type=script&lang=js"
import style0 from "./ADQjhTable.vue?vue&type=style&index=0&id=a5ff8b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ff8b1a",
  null
  
)

export default component.exports